import { render, staticRenderFns } from "./ResourceBuild.vue?vue&type=template&id=7e66fc8e&"
import script from "./ResourceBuild.vue?vue&type=script&lang=js&"
export * from "./ResourceBuild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports